import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Project from "../components/AllProjects/Project"
import Banner from "../components/AllProjects/Banner"
import { BsArrowLeft } from "react-icons/bs"

const ProjectsPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="Home" />
      <Banner />
      <section className="bg-dark pt-3 pb-10 md:pt-5 md:pb-32 lg:pb-48">
        <div className="max-w-screen-md lg:max-w-screen-lg lg:mx-16 xl:mx-auto mx-auto">
          <div className="bg-secondary h-auto mx-2 md:mx-10 lg:mx-0 rounded-lg px-6 md:px-10">
            <div className="grid grid-cols-1 divide-solid divide-y-4 divide-black divide-opacity-25">
              {data.projects.edges.map(({ node: project }) => {
                return <Project key={project.id} project={project} />
              })}
            </div>
          </div>
          <div className="flex justify-center mt-10 md:mt-12 xl:mt-16">
            <Link to="/">
              <button className="flex w-full items-center justify-center text-white border border-white py-3 px-12 font-metropolis font-normal text-sm lg:py-3 lg:px-12 hover:bg-yellow-500 hover:border-yellow-500 hover:text-black focus:outline-none transition-all duration-300 ease-linear tracking-wide uppercase">
                <div className="pr-3 md:pr-3">
                  <BsArrowLeft className="text-lg" />
                </div>
                BACK TO HOME
              </button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    projects: allContentfulMyProjects {
      edges {
        node {
          id
          title
          techStack
          description {
            description
          }
          github
          liveDemo
          image {
            fluid(maxWidth: 800, quality: 100) {
              src
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`

export default ProjectsPage
